import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Plus({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Plus.Outline {...props} /> : <Plus.Solid {...props} />;
}

Plus.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M13 4.92896C13 4.37667 12.5523 3.92896 12 3.92896C11.4477 3.92896 11 4.37667 11 4.92896V11H4.92896C4.37667 11 3.92896 11.4477 3.92896 12C3.92896 12.5523 4.37667 13 4.92896 13H11V19.0711C11 19.6234 11.4477 20.0711 12 20.0711C12.5523 20.0711 13 19.6234 13 19.0711V13H19.0711C19.6234 13 20.0711 12.5523 20.0711 12C20.0711 11.4477 19.6234 11 19.0711 11H13V4.92896Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Plus.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M13 4.92896C13 4.37667 12.5523 3.92896 12 3.92896C11.4477 3.92896 11 4.37667 11 4.92896V11H4.92896C4.37667 11 3.92896 11.4477 3.92896 12C3.92896 12.5523 4.37667 13 4.92896 13H11V19.0711C11 19.6234 11.4477 20.0711 12 20.0711C12.5523 20.0711 13 19.6234 13 19.0711V13H19.0711C19.6234 13 20.0711 12.5523 20.0711 12C20.0711 11.4477 19.6234 11 19.0711 11H13V4.92896Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
